import { getSelectedCustomer } from 'ClientPortal/src/context/SelectedCustomerContext'
import { getValuationApiClient } from 'ClientPortal/src/api/valuationApiClient'
import { useQuery } from '@tanstack/react-query'
import invariant from 'tiny-invariant'
import { useFlags } from 'ClientPortal/src/context/FeatureFlagContext'

type UseGetMarketDataProps = {
    coordinates?: { latitude: number; longitude: number }
    assetId?: string
}

const MARKET_DATA_QUERY_KEY_FACTORY = {
    all: ['MARKET_DATA'] as const,
    lists: () => [...MARKET_DATA_QUERY_KEY_FACTORY.all, 'list'] as const,
    list: (filters: Record<string, unknown>) => [...MARKET_DATA_QUERY_KEY_FACTORY.lists(), { filters }] as const,
}

export function useGetMarketData({ coordinates, assetId }: UseGetMarketDataProps) {
    const { isMarketDataFromValuationEnabled } = useFlags()

    const {
        data: marketData,
        isPending,
        isError,
    } = useQuery({
        enabled: isMarketDataFromValuationEnabled ? !!assetId : !!coordinates,
        queryFn: () => {
            // If live market-data is not enabled we fall back to the market data we have collected for the latest valuation for this asset
            if (isMarketDataFromValuationEnabled) {
                invariant(!!assetId)
                return getValuationApiClient().marketData.getMarketData({ assetId, customerId: getSelectedCustomer()?.uuid })
            }
            invariant(!!coordinates)
            return getValuationApiClient().marketData.getMarketData({ ...coordinates, customerId: getSelectedCustomer()?.uuid })
        },
        queryKey: MARKET_DATA_QUERY_KEY_FACTORY.list({ isMarketDataFromValuationEnabled, coordinates, assetId }),
    })

    return { marketData, isMarketDataPending: isPending, isMarketDataError: isError }
}
